/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define([
	'jquery',
	'./api/InternalRendererAPI',
	'../../../app/util/MobileUtil',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../utils/FeatureFlagUtil',
	'../../../view/features/content/contentView/api/RendererAPI'
], function($, InternalRendererAPI, MobileUtil, APIFactory, FeatureFlagUtil, RendererAPI) {

	/**
	* @class Renderer
	* @hideconstructor
	* @classdesc Renderer feature - provides a renderer
	* @implements {InternalRendererAPI, RendererAPI}
	*/
	class Renderer {
		constructor({ features }) {
			// Remove when cleaning up feature flag MobileLayout
			const addCheck = FeatureFlagUtil.generateChecker(features.API, this);
			addCheck('_isMobileLayoutFeatureEnabled', ['dashboard', 'MobileLayout', 'enabled']);

			this._features = features;
			this._initialize();
		}

		isEnabled() {
			return this._isMobileLayoutFeatureEnabled;
		}

		getAPI(type) {
			if (type === 'internal') {
				if (!this._internalAPI) {
					this._internalAPI = APIFactory.createAPI(this, [RendererAPI, InternalRendererAPI]);
				}
				return this._internalAPI;
			} else {
				if (!this._api) {
					this._api = APIFactory.createAPI(this, [RendererAPI]);
				}
				return this._api;
			}
		}

		isMobile() {
			return (
				MobileUtil.areMobileConditionsMet() &&
				!this._features['DashboardState'].getUiState().authoring
			);
		}

		render() {
			// Coming in another PR - integration with content Renderer
			return Promise.resolve();
		}

		_adjustToolbarBehaviorForMobile() {
			// Monitor the widget toolbar, when shown, disable any handler that will close on scrolling
			// Also, set the focus on the selection widget so that it is fully visible.
			this._features['API'].on('widget:toolbar:show:after', () => {
				$('body').off('wheel.flyoutHideEvent touchstart.flyoutHideEvent');
				$('body').find('.page.pageabsolute, .page.pagecontainer').off('scroll.BaseController');
				const selectedContent = this._features['Canvas'].getSelectedContentList();
				if (selectedContent.length > 0) {
					selectedContent[0].getFeature('ContentViewDOM').getNode().focus();
				}
			});
		}

		_initialize() {
			if (this.isEnabled() && this.isMobile()) {
				document.body.classList.add('mobile-layout');
				document.documentElement.style.height = '100%';
				this._adjustToolbarBehaviorForMobile();
			}
		}
	}

	return Renderer;
});
